export default {
  rectWidth: "960px",
};
